import React, { useState } from "react";
import { BannerTopicsIconsProps } from "./BannerTopicsIcons.types";
import { MapTo } from "@adobe/aem-react-editable-components";
import {
	RangoButton,
	RangoHeading,
	RangoParagraph,
	RangoTopicIcon,
} from "@rango/core";
import {
	BannerTopicsIconsContainer,
	BannerTopicsIconsMainWrapper,
} from "./BannerTopicsIcons.styles";
import { useIsMobile } from "src/utils/js/useIsMobile";
import { useAleloContext } from "src/context/aleloContext";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SpacerDiv from "./SpacerDiv";

const BannerTopicsIcons: React.FC<BannerTopicsIconsProps> = (props) => {
	const { tabsList } = props;

	const [tabIndex, setTabIndex] = useState(0);
	const { setCurrentModal } = useAleloContext();
	const { isMobile } = useIsMobile();

	function openUrl(linkUrl: string, target: string) {
		window.open(linkUrl, target, "noreferrer");
		return null;
	}

	function scrollToSection(anchorSection: string) {
		const section = document.getElementById(anchorSection);
		if (section) section.scrollIntoView({ behavior: "smooth" });
	}

	function ButtonAction(
		actionType: string,
		linkUrl: string,
		target: string,
		step: string,
		anchorSection: string
	) {
		if (actionType === "link") openUrl(linkUrl, target);
		else if (actionType === "modal")
			setCurrentModal({ modal: target, step: step });
		else scrollToSection(anchorSection);
	}

	const sliderSettings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		adaptiveHeight: true,
	};

	return (
		<BannerTopicsIconsMainWrapper>
			{tabsList && tabsList.length > 1 ? (
				<ul className="tabs__list">
					{tabsList.map((tab, index) => (
						<li
							className={`tab__button ${index === tabIndex ? "selected" : ""}`}
							key={index}
							onClick={() => setTabIndex(index)}
						>
							<RangoParagraph
								size="sm"
								{...{
									element_parent: "banner-topics-icons",
									destination: "Categoria: " + tab.tabName,
									element_type: "p",
									title: tab.tabName
								}}
							>{tab.tabName}</RangoParagraph>
						</li>
					))}
				</ul>
			) : null}
			<>
				{tabsList
					? tabsList.map((tab, k) => {
						const tags = {
							element_parent: "banner-topics-icons",
							element_type: tab.actionType === "link" ? "link" : "button",
							destination:
								tab.actionType === "link"
									? tab.linkUrl || ""
									: tab.modalTarget || "",
							title: tab.buttonText,
						};
						return (
							<BannerTopicsIconsContainer
								key={k}
								className={`tabs__panel ${tabIndex === k ? "active" : "hidden"
									}`}
							>
								<div>
									<div className="rango-row topics-icons-banner">
										<div className="rango-col-6 left-div">
											<img
												className="topics-icons-img"
												src={tab.backgroundImage}
												alt={tab.alt}
												style={{
													display: isMobile ? "none" : "block",
												}}
												loading="lazy"
											/>
										</div>										
										<div
											className={`rango-col-6 right-div ${tab.showTabName ? "showTabName" : ""
												}`}
										>
											{tab.showTabName && tab.tabName ? (
												<RangoHeading
													size="md"
													tag="h2"
													style={{ color: "#008060" }}
												>
													{tab.tabName}
												</RangoHeading>
											) : null}
											{tab.tabSubtitle ? (
												<RangoParagraph size="sm">
													{tab.tabSubtitle}
												</RangoParagraph>
											) : null}
											{tab.topicsList &&
												tab.topicsList.map(
													({ headingIcon, heading, subtitle }, i) => (
														<div
															className={`icon-topic-div ${tab.topicsList.length > 3
																? "hide__mobile"
																: ""
																}`}
															key={i}
														>
															<RangoTopicIcon
																icon={headingIcon}
																paragraph={subtitle}
																headingProps={{
																	children: heading,
																	tag: "h2",
																	style: {
																		paddingLeft: "48px",
																	},
																}}
															/>
														</div>
													)
												)}

											{tab.topicsList && tab.topicsList.length > 3 ? (
												<Slider
													{...sliderSettings}
													className="slider__mobile"
												>
													{tab.topicsList.map((topic, index) => {
														return (
															<div className="icon-topic-div" key={index}>
																<RangoTopicIcon
																	icon={topic.headingIcon}
																	paragraph={topic.subtitle}
																	headingProps={{
																		children: topic.heading,
																		tag: "h2",
																		style: {
																			paddingLeft: "48px",
																		},
																	}}
																/>
															</div>
														);
													})}
												</Slider>
											) : null}

											<div className="button-div">
												<RangoButton
													aria-label={tab.buttonText}
													{...tags}
													style={{
														backgroundColor: tab.backgroundColor,
														color: tab.colorButton,
													}}
													onClick={() =>
														ButtonAction(
															tab.actionType,
															tab.linkUrl,
															tab.modalTarget,
															tab.step,
															tab.anchorSection
														)
													}
												>
													{tab.buttonText}
												</RangoButton>
											</div>
										</div>
									</div>
								</div>
							</BannerTopicsIconsContainer>
						);
					})
					: null}
			</>
		</BannerTopicsIconsMainWrapper>
	);
};

export const BannerTopicsIconsEditConfig = {
	emptyLabel: "Banner Topics Icons",

	isEmpty: function (props: BannerTopicsIconsProps) {
		return !props || !props.tabsList;
	},
};

MapTo<BannerTopicsIconsProps>(
	"alelo/components/content/v1/banner-topics-icons"
)(BannerTopicsIcons, BannerTopicsIconsEditConfig);

export default BannerTopicsIcons;
